import Button from '@mui/material/Button'
import { resolveHref } from '@/utilites/resolveHref'

interface ButtonData {
    link?: string
    text?: string
}

interface MainButtonProps {
    button?: ButtonData
}

const MainButton = ({ button }: MainButtonProps) => {
    const href = resolveHref(button?.link)
    return (
        <Button
            variant='outlined'
            color='primary'
            href={href}
        >
            {button?.text || 'Get in touch'}
        </Button>
    )
}

export default MainButton


